import React from 'react';
import { ChevronDown, X, Loader2 } from 'lucide-react';

const VehicleDropdown = ({ id, label, value, displayValue, placeholder, disabled, loading, onClear, children, icon: Icon, logo, logoClass = 'w-6 h-6', image, open, onToggle }) => (
  <div className="relative dropdown-container">
    <label className="block text-xs font-medium text-gray-500 mb-1">{label}</label>
    <button
      type="button"
      data-testid={`vehicle-${id}-dropdown`}
      disabled={disabled || loading}
      onClick={(e) => { e.stopPropagation(); onToggle(id); }}
      className={`w-full flex items-center justify-between border rounded-lg px-4 py-3 text-left transition-all ${
        disabled || loading ? 'bg-gray-100 cursor-not-allowed border-gray-200 text-gray-400' : 'bg-white hover:border-orange-400 border-gray-300 cursor-pointer'
      } ${open ? 'border-orange-500 ring-2 ring-orange-200' : ''}`}
    >
      <div className="flex items-center gap-2 flex-1 min-w-0">
        {loading ? (
          <Loader2 size={18} className="text-orange-500 animate-spin" />
        ) : logo && value ? (
          <img src={logo} alt="" className={`${logoClass} object-contain no-placeholder`} data-testid={`vehicle-${id}-selected-logo`} />
        ) : image ? (
          <img src={image} alt="" className={`w-7 h-7 object-contain no-placeholder ${value ? '' : 'opacity-60 grayscale'}`} data-testid={`vehicle-${id}-icon-image`} />
        ) : (
          Icon && <Icon size={18} className={value ? 'text-orange-500' : 'text-gray-400'} />
        )}
        <span className={`truncate ${value ? 'text-gray-900 font-medium' : 'text-gray-500'}`}>{loading ? 'Chargement...' : (displayValue || placeholder)}</span>
      </div>
      <div className="flex items-center gap-1 flex-shrink-0">
        {value && !disabled && !loading && (
          <span
            role="button"
            tabIndex={0}
            data-testid={`vehicle-${id}-clear`}
            onClick={(e) => { e.stopPropagation(); onClear(); }}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); onClear(); } }}
            className="p-1 hover:bg-gray-100 rounded-full inline-flex"
          >
            <X size={14} className="text-gray-400 hover:text-red-500" />
          </span>
        )}
        <ChevronDown size={18} className={`text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </div>
    </button>
    {open && !disabled && !loading && (
      <div className={`absolute z-50 mt-1 bg-white border border-gray-200 rounded-lg shadow-xl max-h-[26rem] overflow-hidden ${id === 'brand' ? 'w-[min(22rem,90vw)]' : 'w-full'}`}>
        {children}
      </div>
    )}
  </div>
);

export const DropdownSearch = ({ testId, value, onChange, placeholder }) => (
  <div className="p-2 border-b sticky top-0 bg-white">
    <input
      type="text"
      placeholder={placeholder}
      data-testid={testId}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:border-orange-500"
      autoFocus
    />
  </div>
);

export default VehicleDropdown;
